<template>
  <div>
    <el-card shadow="hover" style="text-align: center">
      <div slot="header">
        <el-row>
          <el-col :span="22" style="padding-top: 5px">Most Frequent Repeats</el-col>
          <el-col :span="2">
            <span>
              <el-tooltip content="Explore more" placement="top" :enterable="false">
                <el-button circle size="mini" @click="handleModalOpen"><i class="fas fa-icon-expand"></i></el-button>
              </el-tooltip>
            </span>
          </el-col>
        </el-row>
      </div>
      <modal-unit-bar-frequency height="35vh" :series="barOptions" v-if="barOptions !== null" ></modal-unit-bar-frequency>
    </el-card>
  </div>
</template>

<script>
  import IEcharts from 'vue-echarts-v3/src/full.js';
  import { store } from '../scripts/store.js';
  import { events } from '../scripts/events.js'
  import { repeatFrequency, exponentiateNum } from '../scripts/utils.js';
  import ModalUnitBarFrequency from '../components/ModalUnitBarFrequency';
  const _ = require('lodash');

  export default {
    name: 'MainPlotBarFrequency',
    props: {
      info: Object,
      index: Number,
    },
    components: { ModalUnitBarFrequency },
    asyncComputed: {
      barOptions: function () {
        const plotdata = this.info.RepInfo.PlotData;
        const repeats = Object.keys(plotdata);
        const series = {}
        series.title = '';
        series.data = repeatFrequency(plotdata, 10, "descending");
        series.datatype = "frequency";
        return new Promise(resolve => setTimeout(() => resolve(series), this.index * store.settings.plotUpdateDelayFactor))
      }
    
    },
    methods: {
      handleModalOpen: function () {
        events.$emit('open-modal', 'ModalBarFrequency')
      }
    }
  }
</script>